import { CookieAttributes } from "js-cookie";

import { GlobalInfo } from "./types";

export let globalInfo: GlobalInfo = {
  COOKIE_KEYS_MAP: {
    CountryCode: "countryCode",
    CountryId: "countryId",
    LanguageCode: "languageCode",
    LanguageId: "languageId",
  },
};

/**
 * 初始化全局信息
 * @param initGlobalInfo
 */
export const initGlobalInfo = (initGlobalInfo: GlobalInfo): void => {
  globalInfo = initGlobalInfo;
};

/**
 * 设置cookie信息，因为依赖ctx.req，所以单独进行设置
 * @param cookieOptions
 */
export const setCookieOptions = (cookieOptions: CookieAttributes): void => {
  globalInfo.cookieOptions = {
    ...globalInfo.cookieOptions,
    ...cookieOptions,
  };
};
